module.exports = __webpack_public_path__ + "static/img/pic_ziliaobuqi.f502ff0.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/select_cust_type/04sms/pic_ziliaobuqi.png
// module id = 859
// module chunks = 2